import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

// Don't allow custom attribute to equal an existing non custom attribute value
export function onlyNewCustomAttribute(nonCustomAttrs: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const parentForm = control.parent as FormGroup;

    if (parentForm && !parentForm.get('custom')?.value) {
      return null;
    }
    const attributeName = control.value as string;
    return nonCustomAttrs.indexOf(attributeName) > -1
      ? {nonCustomExist: true}
      : null;
  };
}
